import checkStatus from "../../helpers/checkStatus"
import cleanObject from "../../helpers/cleanObject"

export const PURCHASE_CREDITS = "PURCHASE_CREDITS"
export const PURCHASE_CREDITS_SUCCESS = "PURCHASE_CREDITS_SUCCESS"
export const PURCHASE_CREDITS_FAILURE = "PURCHASE_CREDITS_FAILURE"

const UserActions = {}

UserActions.userNew = function userNew(user) {
  cleanObject(user)
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user)
  })
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    localStorage.setItem("token", res.jwt)
    dispatch({
      type: "USER_LOGIN",
      payload: {
        user: res
      }
    })
    dispatch(UserActions.userProfile())
    return res
  })
}

UserActions.userUpdate = (user) => {
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(user)
  })
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    dispatch({
      type: "USER_UPDATED",
      payload: {
        profile: res.data
      }
    })
    return res
  })
}

UserActions.userChangePassword = (user) => {
  cleanObject(user)
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user/password`, {
    method: "PATCH",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(user)
  })
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    dispatch({
      type: "USER_UPDATED",
      payload: {
        profile: res.data
      }
    })
    return res
  })
}

UserActions.userLogin = function userLogin(user) {
  // Alert.closeAll();
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user/login`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(user)
  })
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    localStorage.setItem("token", res.jwt)
    dispatch({
      type: "USER_LOGIN",
      payload: {
        user: res
      }
    })
    dispatch(UserActions.userProfile())
    return res
  })
}

UserActions.userProfile = function userProfile() {
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user/profile`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    }
  })
  // .then(checkStatus)
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    dispatch({
      type: "USER_PROFILE",
      payload: {
        data: res.data
      }
    })
    return res
  })
  .catch((err) => {
    if (err.error === "Unauthorized") {
      dispatch(UserActions.userLogout())
    }
  })
}

UserActions.userStripe = function userStripe(stripeInfo) {
  return dispatch => fetch(`${process.env.REACT_APP_API_HOST}/user/stripe`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}` || ""
    },
    body: JSON.stringify(stripeInfo)
  })
  // .then(checkStatus)
  .then((res) => { return res.json() })
  .then(checkStatus)
  .then((res) => {
    dispatch({
      type: "USER_STRIPE",
      payload: {
        profile: res.data
      }
    })
    return res
  })
}

UserActions.userLogout = function userLogout() {
  localStorage.removeItem("token")
  // Send token to serer to invalidate
  return {
    type: "USER_LOGOUT"
  }
}

export function purchaseCredits(quantity) {
  return {
    type: PURCHASE_CREDITS,
    payload: quantity
  }
}

UserActions.purchaseCreditsSuccess = (response) => {
  return {
    type: PURCHASE_CREDITS_SUCCESS,
    payload: response
  }
}

UserActions.purchaseCreditsFailure = (err) => {
  return {
    type: PURCHASE_CREDITS_FAILURE,
    error: err.result.message
  }
}

export default UserActions
